// src/Pages/editarusuario.jsx

import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from 'react-router-dom';
import '../Empresas/editarempresa'; // Reutilizando CSS
import MenuLateral from "../Components/MenuPrincipal/MenuLateral";
import UsuarioForm from "../Components/UsuarioForm/UsuarioForm";
import { useAuth } from "../Context/auth";

function EditarUsuario() {
    const { id: usuarioId } = useParams();
    const { currentUser } = useAuth();
    const navigate = useNavigate();

    const [initialData, setInitialData] = useState(null);
    const [mensagem, setMensagem] = useState('');
    const [loadingData, setLoadingData] = useState(true);
    const [saving, setSaving] = useState(false);

    useEffect(() => {
        const fetchUsuarioData = async () => {
            if (!currentUser || !usuarioId) return;
            try {
                const token = await currentUser.getIdToken();
                const API_URL = process.env.REACT_APP_API_URL;
                const response = await fetch(`${API_URL}/api/usuarios/${usuarioId}`, {
                    headers: { 'Authorization': `Bearer ${token}` }
                });
                if (!response.ok) throw new Error("Usuário não encontrado.");
                const data = await response.json();
                setInitialData(data);
            } catch (error) {
                setMensagem("Erro ao carregar dados do usuário.");
            } finally {
                setLoadingData(false);
            }
        };
        fetchUsuarioData();
    }, [usuarioId, currentUser]);

    async function handleAlterarUsuario(formData) {
        setMensagem('');
        setSaving(true);
        try {
            const token = await currentUser.getIdToken();
            const API_URL = process.env.REACT_APP_API_URL;
            const response = await fetch(`${API_URL}/api/usuarios/${usuarioId}`, {
                method: 'PUT',
                headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
                body: JSON.stringify(formData)
            });
            if (!response.ok) {
                const errorData = await response.json();
                throw new Error(errorData.error || "Falha ao atualizar usuário.");
            }
            navigate('/app/usuarios');
        } catch (erro) {
            setMensagem(erro.message);
        } finally {
            setSaving(false);
        }
    }

    if (loadingData) return (
        <div className="form-page-container" style={{ display: 'flex', paddingTop: 0 }}>
            <MenuLateral />
            <div className="content-with-sidebar d-flex justify-content-center align-items-center" style={{ width: '100%' }}>
                <p>Carregando...</p>
            </div>
        </div>
    );

    return (
        <div className="form-page-container" style={{ display: 'flex', paddingTop: 0 }}>
            <MenuLateral />
            <div className="content-with-sidebar">
                <div className="page-header">
                    <div className="d-flex align-items-center gap-3">
                        <button className="btn btn-link text-secondary p-0" onClick={() => navigate('/app/usuarios')} title="Voltar">
                            <i className="fas fa-arrow-left fa-lg"></i>
                        </button>
                        <h1 className="page-title m-0">Editar <span className="highlight">Usuário</span></h1>
                    </div>
                </div>
                {mensagem && <div className="alert alert-danger mt-3">{mensagem}</div>}
                <div className="form-card-container">
                    <div className="form-container">
                        {initialData ? (
                            <UsuarioForm
                                initialData={initialData}
                                onSubmit={handleAlterarUsuario}
                                isEditing={true}
                                loading={saving}
                            />
                        ) : <p>Nenhum dado para exibir.</p>}

                    </div>
                </div>
            </div>
        </div>
    );
}
export default EditarUsuario;